// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"sms-subscribe_productcontent__vYsGv"};